import React, { useMemo } from 'react'
import { Card } from 'react-bootstrap'
import './Product.scss'
import placeholderImage from '../../assets/images/detailsPlaceholder.jpg'
import { formatPrice } from '../../helpers'
import { useNavigate } from 'react-router-dom'

export default function Product({
  product,
  onCardClick,
  isCompanyVisible = true,
}) {
  const navigate = useNavigate()

  let image = placeholderImage

  if (product?.images?.length > 0) {
    image = product.images[0].path
  }

  const price = useMemo(() => {
    let formattedPrice = ''

    if (product.price_type === 'fixed') {
      formattedPrice = formatPrice(product.price)
    } else {
      const minFormattedPrice = formatPrice(product.min_price)
      const maxFormattedPrice = formatPrice(product.max_price)

      if (minFormattedPrice) {
        formattedPrice = minFormattedPrice
      }

      if (maxFormattedPrice) {
        formattedPrice = `${formattedPrice} - ${maxFormattedPrice}`
      }
    }

    return formattedPrice
  }, [product])

  const companyImage = useMemo(() => {
    if (product.company?.cover_image) {
      return product.company?.cover_image
    } else {
      return placeholderImage
    }
  }, [])

  return (
    <Card
      onClick={onCardClick}
      className="shadow border-0 h-100 pointer product">
      <Card.Img variant="top" src={image} alt={product.title} />
      <Card.Body className="d-flex flex-column justify-content-between p-2">
        <div>
          {isCompanyVisible ? (
            <div
              className="company"
              onClick={e => {
                e.stopPropagation()
                navigate(`/firma/${product.company?.id}`)
              }}>
              <img src={companyImage} alt="Company Logo" />
              <span>{product.company?.name}</span>
            </div>
          ) : null}

          <Card.Title className="title">{product.title}</Card.Title>
        </div>

        <div className="price-div">
          <span>{price ? `${price} KM` : ''}</span>
        </div>
      </Card.Body>
    </Card>
  )
}
